import { render, staticRenderFns } from "./CPI-PPI.vue?vue&type=template&id=7718efea&scoped=true&"
import script from "./CPI-PPI.vue?vue&type=script&lang=ts&"
export * from "./CPI-PPI.vue?vue&type=script&lang=ts&"
import style0 from "./CPI-PPI.vue?vue&type=style&index=0&id=7718efea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718efea",
  null
  
)

export default component.exports